import { ChakraComponent } from '@chakra-ui/system';
import { TagLabel as TagLabelComponent, TagProps } from '@chakra-ui/tag';
import * as React from 'react';

export type ITagLabelProps = ChakraComponent<'div', TagProps>;

export const TagLabel = ((props: TagProps) => <TagLabelComponent {...props} />) as ITagLabelProps;
